import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import { Outlet, Navigate } from "react-router-dom";
import { useAppSelector } from "../store/customHooks";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  root: {
		"&&.css-gcpdnc": {
	     padding:0
     }

  },
  
});
const PrivateOutlet = () => {
	  const classes = useStyles();
	  let auth= localStorage.getItem("AUTH_DATA")

//   let auth = useAppSelector((state: any) => state.auth.authData);
	return auth ? (
		<>
			<Box component="main" className={classes.root}
				sx={{ flexGrow: 1, p: 2 }}
			>
				<Outlet />
			</Box>
		</>
	) : (
		<Navigate to="/login" />
	);
};

export default PrivateOutlet;
